var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-weight") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs",
    transform: "translate(-356.000000, -575.000000)",
    stroke: "#010003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-weight",
    transform: "translate(356.000000, 575.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 4.5,
    x2: 11.5,
    y2: 8.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0.5 L0.5,2.5 C0.5,3.605 1.395,4.5 2.5,4.5 L20.5,4.5 C21.605,4.5 22.5,3.605 22.5,2.5 L22.5,0.5 L0.5,0.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,8.5 L11.5,8.5 C15.918,8.5 19.5,12.082 19.5,16.5 L19.5,22.5 L3.5,22.5 L3.5,16.5 C3.5,12.082 7.082,8.5 11.5,8.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.5,
    cy: 15.5,
    r: 3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeight);
export default __webpack_public_path__ + "static/media/icon-weight.e29b6534680b2a8774a7b1c2bbe1d2bf.svg";
export { ForwardRef as ReactComponent };